/**
 * Validates a URL to prevent open redirect vulnerabilities.
 * Only allows relative URLs or URLs from the same origin.
 */
export const validateReturnToUrl = (url?: string): string | null => {
	if (!url) {
		return null;
	}

	try {
		// Decode the URL first
		const decodedUrl = decodeURIComponent(url);

		// Reject protocol-relative URLs (e.g., //evil.com) - these redirect using the current protocol
		if (decodedUrl.startsWith('//')) {
			console.warn('Protocol-relative URL blocked:', decodedUrl);
			return null;
		}

		// Relative URLs starting with / are safe
		if (decodedUrl.startsWith('/')) {
			return decodedUrl;
		}

		// Bare paths (no leading /) are safe if they don't contain protocol markers
		if (
			!decodedUrl.includes('://') &&
			!decodedUrl.includes('.') &&
			!decodedUrl.includes(':')
		) {
			return decodedUrl;
		}

		// Parse the URL to check if it's from the same origin
		const urlObj = new URL(decodedUrl);
		const currentOrigin = window.location.origin;

		// Only allow URLs from the same origin
		if (urlObj.origin === currentOrigin) {
			return decodedUrl;
		}

		// Reject external URLs to prevent open redirects
		console.warn('Open redirect attempt blocked:', decodedUrl);
		return null;
	} catch (error) {
		// If URL parsing fails, reject it
		console.warn('Invalid returnTo URL:', url, error);
		return null;
	}
};
